module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"National Center for Wellness and Recovery","short_name":"National Center for Wellness and Recovery","start_url":"/","display":"standalone","icon":".forestry/content/images/favicon-white.svg"},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1000,"linkImagesToOriginal":false},
    }]
